import React, { useEffect, useState } from "react";
import styles from "./holiday-list-view.module.css";
import CustomTable from "../../../../common/custom-table/custom-table";
import dayjs from "dayjs";
import { DATE_FORMAT } from "../../../../constants/common";
import StatusChip from "../../../../components/status-chip/status-chip";
import { getEventsList } from "../../../../services/dashboard";
import { toast } from "react-toastify";
import { capitalizeFirstLetter } from "../../../../utils/format-text/fomat-text";
import moment from "moment";
import SVGIcon from "../../../../constants/SVGIcon";
import CustomPopover from "../../../../common/custom-popover/custom-popover";

const HolidayListView = ({
  handleEditHoliday,
  handleDeleteHoliday,
}) => {
  const [loading, setLoading] = useState(false);
  const [pageNo, setPageNo] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalCount, setTotalCount] = useState(0);
  const [holidayList, setHolidayList] = useState([]);

  const columns = [
    {
      title: "Holiday Name",
      dataIndex: "reason",
      key: "reason",
      sorter: (a, b) => a?.name - b?.name,
      render: (value) => value || "-",
    },
    {
      title: "Date",
      dataIndex: "date",
      key: "date",
      sorter: (a, b) =>
        dayjs(a?.date, DATE_FORMAT.DD_MM_YYYY).valueOf() -
        dayjs(b?.date, DATE_FORMAT.DD_MM_YYYY).valueOf(),
      render: (value) => moment(value).format("DD-MMM-YYYY") || "-",
    },
    {
      title: "Day",
      dataIndex: "day_of_week",
      key: "day_of_week",
      sorter: (a, b) => a?.day_of_week - b?.day_of_week,
      render: (value) => capitalizeFirstLetter(value) || "-",
    },
    {
      title: "Holiday Type",
      dataIndex: "type",
      key: "type",
      sorter: (a, b) => a?.type - b?.type,
      render: (value) => capitalizeFirstLetter(value) || "-",
    },
    {
      title: "Description",
      dataIndex: "description",
      key: "description",
      sorter: (a, b) => a?.description - b?.description,
      render: (value) => capitalizeFirstLetter(value) || "-",
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      sorter: (a, b) => a?.status - b?.status,
      render: (value) => <StatusChip status={value} />,
    },
    {
      title: "Action",
      key: "action",
      align: "center",
      render: (_, record) => (
        <div className={styles.actionItemWrapper}>
          <SVGIcon
            name={"edit-icon"}
            width={"20"}
            height={"20"}
            stroke={"#3BB44B"}
            onClick={() => handleEditHoliday(record)}
          />
          <CustomPopover
            message="Are you sure you want to delete this Holiday?"
            confirmText="Delete"
            cancelText="Cancel"
            onConfirm={() => handleDeleteHoliday(record?.id)}
          >
            <SVGIcon
              name={"delete"}
              width={"20"}
              height={"20"}
              stroke={"rgba(243, 17, 17, 1)"}
            />
          </CustomPopover>
        </div>
      ),
    },
  ];

  useEffect(() => {
    setPageNo(1);
    fetchHolidayList();
  }, []);

  const fetchHolidayList = async (tempPage = pageNo, tempPageSize = pageSize) => {
    try {
      setLoading(true);
      const payload = {
        page: tempPage,
        pageSize: tempPageSize,
      };
      const resp = await getEventsList(payload);
      const data = resp?.data;

      setHolidayList(data?.data);
      setTotalCount(data?.totalRecords);
      setLoading(false);
    } catch (err) {
      setLoading(false);
      toast.error("Error Retrieving Stats");
    } finally {
      setLoading(false);
    }
  };

  const handleChangePage = (page, pageSize) => {
    setPageNo(page);
    setPageSize(pageSize);
    fetchHolidayList(page, pageSize);
  };

  return (
    <CustomTable
      columns={columns}
      dataSource={holidayList}
      loading={loading}
      headerColor="#667085"
      headerBackgroundColor="#F9FAFB"
      total={totalCount}
      pageSize={pageSize}
      currentPage={pageNo}
      handlePageChange={handleChangePage}
    />
  );
};

export default HolidayListView;
